/** Shared reads for historic guardian field keys. */
export function gVal(guardian, keys, logical) {
  const k = keys[logical];
  return guardian?.[k] ?? "";
}

export function formatHistoricSsnDisplay(ssn) {
  if (!ssn || ssn.length < 4) return ssn;
  return `XXX-XX-${ssn.slice(-4)}`;
}
